import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
  lClientKey: "",
  lDepartmentKey: "",
  sInstrumentTypeKey: "",
  plScopeTypeKey: "",
  sSerialNumber: "",
  lQuantity: "",
  nUnitCost: "",
};

export const AddPendingContractConfig = {
  name: "Specifications",
  initialState: initState,
  section: [
    {
      sectionId: "specificationsSection",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="row"></div>,
          fields: [
            {
              id: "lClientKey",
              label: "Client :",
              Field_Name: "Client",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lClientKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Client",
                options: [],
              },
          
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lDepartmentKey",
              label: "Department :",
              Field_Name: "Department",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lDepartmentKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Department",
                options: [],
              },
         
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "sInstrumentTypeKey",
              label: "Instrument Type :",
              Field_Name: "Instrument Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "sInstrumentTypeKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Instrument Type",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-4 col-md-8 col-12 mb-2",
              },
            },
            {
              id: "plScopeTypeKey",
              label: "Model :",
              Field_Name: "Model",
              fieldType: FormFieldTypes.SELECT,
              dataField: "plScopeTypeKey",
              fieldSetting: {
                placeholder: "Select Model",
                allowSpace: true,
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-8 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "sSerialNumber",
              label: "Serial Number : ",
              Field_Name: "Serial Number",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sSerialNumber",
              fieldSetting: {
                placeholder: "Enter Serial Number",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-4 col-md-4 col-12 mb-2 ",
              },
            },
            {
              id: "lQuantity",
              label: "Quantity : ",
              Field_Name: "Quantity",
              fieldType: FormFieldTypes.INPUT,
              dataField: "lQuantity",
              fieldSetting: {
                placeholder: "Enter Quantity",
                allowSpace: true,
                isDisable: false,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-4 col-md-4 col-12 mb-2 ",
              },
            },
             {
              id: "nUnitCost",
              label: "Unit Cost : ",
              Field_Name: "Unit Cost",
              fieldType: FormFieldTypes.INPUT,
              dataField: "nUnitCost",
              fieldSetting: {
                placeholder: "Enter Unit Cost",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-4 col-md-4 col-12 mb-2 ",
              },
            },
          ],
        },
      ],
    },
  ],
};
